import { APIOptions } from 'primereact/api'
import { twMerge } from 'tailwind-merge'

export const ptOptions: Partial<APIOptions> = {
  ptOptions: {
    mergeProps: true,
    mergeSections: true,
    classNameMergeFunction: twMerge,
  },
}

export const borderLessClassNames =
  'col-span-1 min-w-[250px] rounded-none border-x-[0px] border-b-[1px] border-t-[0px] border-solid border-[#605e5c]'
